import { InputAdornment, TextField } from '@mui/material';
import { ClearIcon } from '@mui/x-date-pickers/icons';
import SearchIcon from '../../assets/Icons/search-normal.svg';

type CustomSearchProps = {
    searchTerm: string;
    filterChange: (filterValue: string) => any,
    handleClear: () => void;
}

const CustomSearch = ({ searchTerm, filterChange, handleClear }: CustomSearchProps) => {

    const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        filterChange(event.target.value)
    };

    return (
        <TextField
            value={searchTerm}
            onChange={handleSearchChange}
            placeholder="Search"
            autoComplete="off"
            slotProps={{
                input: {
                    startAdornment: (
                        <InputAdornment position="start">
                            <img src={SearchIcon} alt="Icon" />
                        </InputAdornment>
                    ),
                    endAdornment: searchTerm ? (
                        <span
                            onClick={handleClear}>
                            <ClearIcon style={{ width: '20px', cursor: "pointer", position: 'absolute', top: '50%', right: '5px', transform: 'translateY(-50%)', color: '#8D8D8D' }} />
                        </span>
                    ) : null
                },
            }}

        />
    )
}

export default CustomSearch